<template>
  <Stats />
</template>

<script>
import Stats from "@/components/stats.vue";
import { mapState } from "vuex";

export default {
  name: "StatsPage",
  components: { Stats },
  metaInfo: {
    title: "Stats",
  },
  mounted() {
    if (this.userType !== "artist") {
      this.$router.replace({ name: "Home" });
    }
  },
  computed: {
    ...mapState(["userType"]),
  },
};
</script>
